var parallaxElements = [];

jQuery(document).ready(function(){
    initParallaxElements();
    checkParallaxElements();

    jQuery(window).scroll(checkParallaxElements);
})

function initParallaxElements(){
    jQuery('.vif-parallax-effect, .vif-parallax-corner-effect').each(function(){
        let currentParallaxItem = jQuery(this);
        let currentParallaxStrength = 0;

        if(currentParallaxItem[0].hasAttribute('data-corner-parallax-strength')){
            currentParallaxStrength = currentParallaxItem.data('corner-parallax-strength');
            currentParallaxItem.removeAttr('data-corner-parallax-strength');
            if(currentParallaxStrength){
                parallaxElements.push({
                    item: currentParallaxItem,
                    parallax: currentParallaxStrength,
                    corner: true,
                })
            }
        }
        if(currentParallaxItem[0].hasAttribute('data-parallax-strength')){
            currentParallaxStrength = currentParallaxItem.data('parallax-strength');
            currentParallaxItem.removeAttr('data-parallax-strength');
            if(currentParallaxStrength){
                parallaxElements.push({
                    item: currentParallaxItem,
                    parallax: currentParallaxStrength,
                    corner: false
                })
            }
        }
        
    });
}
function checkParallaxElements(){
    const scrollTop = jQuery(window).scrollTop();
    const windowHeight = jQuery(window).outerHeight(true);
    const middleScrollPos = scrollTop + (windowHeight/2);
    parallaxElements.forEach((parallaxElement)=>{
        const topItemPos = parallaxElement.item.offset().top;
        const itemHeight = parallaxElement.item.outerHeight(true);
        const middleItemPos = topItemPos+(itemHeight/2);
        let step = (middleScrollPos-middleItemPos)/((windowHeight/2)+(itemHeight/2));
        step = step>1 ? 1 : (step<-1 ? -1 : step);
        let parallax = parallaxElement.parallax*step*-1;
        parallax = parallax/16;
        parallax = Math.floor(parallax*100)/100;
        if(parallaxElement.corner) parallaxElement.item.css('--corner-translate', parallax+'em');
        else parallaxElement.item.css('transform', 'translateY('+parallax+'em)');
    })
}